export default __webpack_public_path__ + "static/media/paintswap.14139024.png";